import React, { useState, useEffect, createContext } from "react";
import "./App.scss";
import Form from "./pages/Form";
import ThankYouPage from "./pages/ThankYouPage";
import Loading from "./components/Loading";
import Popup from "./components/Popup";

export const GlobalContext = createContext();

function App() {
  const [width, setWidth] = useState(window.innerWidth);
  const [currentFormStep, setCurrentFormStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [phase, setPhase] = useState(1);
  const dataValue = {
    isLoading,
    setIsLoading,
    currentFormStep,
    setCurrentFormStep,
    phase,
    setPhase,
  };

  useEffect(() => {
    const updateWindowDimensions = () => {
      const newWidth = window.innerWidth;
      setWidth(newWidth);
    };
    window.addEventListener("resize", updateWindowDimensions);

    return () => window.removeEventListener("resize", updateWindowDimensions);
  }, []);

  const currentDate = new Date();
  const targetDate = new Date("2025-09-26T23:59:59");
  const isAfterTargetDate = currentDate > targetDate;
  useEffect(() => {
    if (isAfterTargetDate) {
      setPhase(2);
    }
  }, []);
  const closeDate = new Date("2025-10-17T23:59:59");
  return (
    <GlobalContext.Provider value={dataValue}>
      <div className="App">
        {currentDate > closeDate && (
          <Popup
            detail={[
              "The registration period has ended.",
              "登記時段已經結束",
            ]}
            haveButton={false}
            haveCloseButton={false}
          />
        )}

        {isLoading ? <Loading /> : <></>}
        <div className="logo-container">
          {width <= 720 ? (
            <img
              className="banner"
              alt="banner"
              src={process.env.PUBLIC_URL + "/assets/img/kv_01.png"}
            />
          ) : (
            <img
              className="banner"
              alt="banner"
              src={process.env.PUBLIC_URL + "/assets/img/kv_01.png"}
            />
          )}
        </div>
        {currentFormStep === 1 ? (
          <div className="title-container">
            <div className="title">
              購買 Galaxy Z Fold7 | Z Flip7，贏取拉闊音樂會門票！ <br />
              Buy a Galaxy Z Fold7 | Z Flip7 and win a Music is Live ticket!
            </div>
            <br />
            感謝您的購買，完成登記及回答創意問題，即有機會贏取 <br></br>《
            b.balance呈獻 拉闊音樂會 Most Wanted 鄭秀文x張敬軒 》門票！<br></br>
            與 Samsung 一起享受超凡的音樂體驗。
            <br />
            Thank you for your purchase. Register and answer a creative question
            to stand a chance to win a <br></br>《 b.balance presents Music is
            Live Most Wanted Sammi Cheng x Hins Cheung 》ticket!
            <br />
            Enjoy the amazing music experience with Samsung.
            <br />
            <img
              className="quota-mobile"
              alt="banner"
              src={process.env.PUBLIC_URL + "/assets/img/mobile.jpg"}
            />
            <div className="quota-table">
              <table>
                <tr>
                  <th></th>
                  <th>
                    購買及登記期 <br />
                    Purchase and registration period
                  </th>
                  <th>
                    結果公佈 <br />
                    Result announcement
                  </th>
                  <th>
                    名額 <br />
                    Quota
                  </th>
                </tr>
                <tr>
                  {phase == 2 ? (
                    <td>
                      第一階段
                      <br />
                      (已完結) <br />
                      Phase 1 <br />
                      (Ended)
                    </td>
                  ) : (
                    <td>
                      第一階段
                      <br />
                      Phase 1
                    </td>
                  )}

                  <td>07.09 – 26.09, 2025</td>
                  <td>29.09, 2025</td>
                  <td>50</td>
                </tr>
                <tr>
                  <td>
                    第二階段 <br />
                    Phase 2
                  </td>
                  <td>27.09 – 17.10, 2025</td>
                  <td>20.10, 2025</td>
                  <td>50</td>
                </tr>
              </table>
            </div>
            <div>
              立即完成以下表格，即有機會贏取拉闊音樂會門票！
              <br /> Complete the form below now and stand for a chance to win a
              Music is Live ticket!
            </div>
          </div>
        ) : (
          <></>
        )}
        <div className="page-container">
          {currentFormStep === 1 ? (
            <Form />
          ) : currentFormStep === 2 ? (
            <ThankYouPage />
          ) : (
            <></>
          )}
        </div>
      </div>
    </GlobalContext.Provider>
  );
}

export default App;
